<div class="principal-page">
  <!-- Hero Banner -->
  <div class="hero-banner">
    <div class="hero-overlay"></div>
    <div class="hero-particles">
      <span></span><span></span><span></span><span></span><span></span>
    </div>
    <div class="hero-content">
      <div class="hero-badge">
        <i class="fas fa-chalkboard-teacher"></i>
      </div>
      <h1 class="hero-title">Principal's Desk</h1>
      <p class="hero-subtitle">A message of vision, dedication, and excellence</p>
      <div class="hero-divider">
        <span></span><i class="fas fa-mortar-pestle"></i><span></span>
      </div>
    </div>
  </div>

  <div class="container content-wrapper">
    <!-- Message Card -->
    <section class="message-section">
      <div class="message-card">
        <div class="message-bg-pattern"></div>

        <!-- Quote Icon -->
        <div class="quote-icon-top">
          <i class="fas fa-quote-left"></i>
        </div>

        <!-- Greeting -->
        <p class="greeting">Dear Students,</p>

        <!-- Message Body -->
        <div class="message-body">
          <p>College of Pharmacy (POLY), Akluj has so far produced 30+ batches of Pharmacists. Most of them are serving the society as pill-dispensers rather than "Managed Health Care Providers".</p>

          <p>The College has made overall progress in the field of Technical Education as one of the leading institutions in the state of Maharashtra. The college has maintained high standards of discipline &amp; achieved excellence in the field of Pharmacy education and has also taken interest in community welfare related activities such as environmental management, public health care, drug information and patient education etc.</p>

          <p>All this has been visible because of continuous efforts, hard work and co-operation of management, staff, students and NGO's. Health has been of prime importance to mankind since pre-historic times. Pharmaceutical Scientists have to play an important role in attaining a better quality of life.</p>

          <p class="highlight-text">I am sure that the combination of vision of our management, complete dedication of our faculty and efforts of our students will work towards setting global standards in Pharmaceutical education.</p>
        </div>

        <!-- Quote Icon -->
        <div class="quote-icon-bottom">
          <i class="fas fa-quote-right"></i>
        </div>

        <!-- Signature -->
        <div class="signature-block">
          <div class="signature-line"></div>
          <h4 class="signature-name">Mr. Devadkar N.B.</h4>
          <p class="signature-title">Principal</p>
          <p class="signature-org">College of Pharmacy (Poly), Akluj</p>
        </div>
      </div>
    </section>

    <!-- Vision Cards -->
    <section class="vision-section">
      <div class="vision-grid">
        <div class="vision-card">
          <div class="vision-icon vi-blue"><i class="fas fa-bullseye"></i></div>
          <h5>Our Vision</h5>
          <p>Setting global standards in pharmaceutical education through innovation and excellence</p>
        </div>
        <div class="vision-card">
          <div class="vision-icon vi-purple"><i class="fas fa-hands-helping"></i></div>
          <h5>Community Focus</h5>
          <p>Dedicated to environmental management, public health care, and patient education</p>
        </div>
        <div class="vision-card">
          <div class="vision-icon vi-teal"><i class="fas fa-medal"></i></div>
          <h5>Excellence</h5>
          <p>Maintaining the highest standards of discipline and academic achievement</p>
        </div>
      </div>
    </section>
  </div>
</div>